var option_default = {
  "option": "DeQHg",
  "user_choice": "tsuEH",
  "check": "go31V",
  "image": "-pM46",
  "input": "t-EvV",
  "title": "KHNf8",
  "centered": "S6syw",
  "with_result": "ZaRdK",
  "list": "Na6QH",
  "with_image": "ohPzM",
  "progress": "da2CI",
  "progress_value": "g-trO",
  "label": "ilvz8",
  "cta": "QhN4f",
  "adornment_icon": "pFtcw",
  "remove": "wW1iK",
  "removeButton": "wFi3k",
  "removeButtonIcon": "ErlPH",
  "overlay": "_267a7",
  "shown": "rbg7v",
  "dark": "-npa0",
  "spinner": "_54bC-",
  "spin": "_42rWi"
};
export {
  option_default as default
};
//# sourceMappingURL=option-scss.js.map
